/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DiscountCalculationType = {
    Flat: 'Flat',
    ByCount: 'ByCount'
} as const;
export type DiscountCalculationType = typeof DiscountCalculationType[keyof typeof DiscountCalculationType];


export function instanceOfDiscountCalculationType(value: any): boolean {
    for (const key in DiscountCalculationType) {
        if (Object.prototype.hasOwnProperty.call(DiscountCalculationType, key)) {
            if (DiscountCalculationType[key as keyof typeof DiscountCalculationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DiscountCalculationTypeFromJSON(json: any): DiscountCalculationType {
    return DiscountCalculationTypeFromJSONTyped(json, false);
}

export function DiscountCalculationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountCalculationType {
    return json as DiscountCalculationType;
}

export function DiscountCalculationTypeToJSON(value?: DiscountCalculationType | null): any {
    return value as any;
}

export function DiscountCalculationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DiscountCalculationType {
    return value as DiscountCalculationType;
}

